import * as i0 from '@angular/core';
import { forwardRef, EventEmitter, Component, ViewEncapsulation, Input, Output, ViewChild, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import * as i1 from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import * as i2 from '@eui/components/legacy/ux-datepicker';
import { UxDatepickerComponentModule } from '@eui/components/legacy/ux-datepicker';
import * as i3 from '@eui/components/legacy/atomic';
import { UxLabelComponentModule } from '@eui/components/legacy/atomic';
import { CommonModule } from '@angular/common';

const UX_DATERANGESELECTOR_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => UxDateRangeSelectorComponent),
    multi: true,
};
class UxDateRangeSelectorComponent {
    constructor(translateService) {
        this.translateService = translateService;
        this.isFirstOpened = false;
        this.isSecondOpened = false;
        this.selectedDates = [
            { value: '' },
            { value: '' }
        ];
        this.destroy$ = new Subject();
        this.styleClass = '';
        this.e2eAttr = 'ux-date-range-selector';
        this._noButton = true;
        this.firstSelectedDate = new EventEmitter();
        this.secondSelectedDate = new EventEmitter();
        this.propagateChange = (_) => {
        };
        this.propagateTouched = () => {
        };
    }
    get noButton() { return this._noButton; }
    set noButton(value) { this._noButton = coerceBooleanProperty(value); }
    ngOnInit() {
        if (!this.firstPickersLabel) {
            this.translateService.stream('eui.daterangeselector.FIRSTPICKERSLABEL').pipe(takeUntil(this.destroy$))
                .subscribe((result) => {
                this.firstPickersLabel = result;
            });
        }
        if (!this.secondPickersLabel) {
            this.translateService.stream('eui.daterangeselector.SECONDPICKERSLABEL').pipe(takeUntil(this.destroy$))
                .subscribe((result) => {
                this.secondPickersLabel = result;
            });
        }
        if (!this.firstPickersPlaceholder) {
            this.translateService.stream('eui.daterangeselector.FIRSTPICKERSPLACEHOLDER').pipe(takeUntil(this.destroy$))
                .subscribe((result) => {
                this.firstPickersPlaceholder = result;
            });
        }
        if (!this.secondPickersPlaceholder) {
            this.translateService.stream('eui.daterangeselector.SECONDPICKERSPLACEHOLDER').pipe(takeUntil(this.destroy$))
                .subscribe((result) => {
                this.secondPickersPlaceholder = result;
            });
        }
    }
    openSecondPicker(event) {
        if (this.isSecondOpened === false) {
            this.secondPicker['uxdatepicker'].open();
            this.isFirstOpened = true;
        }
        this.firstSelectedDate.emit(event);
        this.selectedDates[0].value = event;
        if (this.selectedDates[0].value !== '' && this.selectedDates[1].value !== '') {
            this.propagateChange(this.selectedDates);
        }
    }
    openFirstPicker(event) {
        if (this.isFirstOpened === false) {
            this.firstPicker.uxdatepicker.open();
            this.isSecondOpened = true;
        }
        this.secondSelectedDate.emit(event);
        this.selectedDates[1].value = event;
        if (this.selectedDates[0].value !== '' && this.selectedDates[1].value !== '') {
            this.propagateChange(this.selectedDates);
        }
    }
    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.unsubscribe();
    }
    writeValue(value) {
        let values = [];
        values = value || '';
        this.startDateDefaultValue = values[0].value;
        this.endDateDefaultValue = values[1].value;
    }
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    registerOnTouched(fn) {
        this.propagateTouched = fn;
    }
}
/** @nocollapse */ UxDateRangeSelectorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxDateRangeSelectorComponent, deps: [{ token: i1.TranslateService }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ UxDateRangeSelectorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.3", type: UxDateRangeSelectorComponent, selector: "ux-date-range-selector", inputs: { styleClass: "styleClass", e2eAttr: "e2eAttr", firstPickersLabel: "firstPickersLabel", secondPickersLabel: "secondPickersLabel", firstPickersPlaceholder: "firstPickersPlaceholder", secondPickersPlaceholder: "secondPickersPlaceholder", noButton: "noButton", maxDate: "maxDate", startDateDefaultValue: "startDateDefaultValue", endDateDefaultValue: "endDateDefaultValue" }, outputs: { firstSelectedDate: "firstSelectedDate", secondSelectedDate: "secondSelectedDate" }, providers: [UX_DATERANGESELECTOR_ACCESSOR], viewQueries: [{ propertyName: "firstPicker", first: true, predicate: ["firstPicker"], descendants: true }, { propertyName: "secondPicker", first: true, predicate: ["secondPicker"], descendants: true }], ngImport: i0, template: "<div class=\"ux-date-range-selector {{ styleClass }}\" attr.data-e2e=\"{{ e2eAttr }}\">\n    <div class=\"ux-date-range-selector__first-picker\">\n        <ux-a-label [label]=\"firstPickersLabel\"></ux-a-label>\n        <ux-datepicker\n            #firstPicker\n            [noButton]=\"noButton\"\n            [placeholder]=\"firstPickersPlaceholder\"\n            [maxDate]=\"secondPicker.input.value || endDateDefaultValue ? secondPicker.input.value || endDateDefaultValue: maxDate\"\n            (onDateSelect)=\"openSecondPicker($event)\"\n            [value]=\"startDateDefaultValue\">\n        </ux-datepicker>\n    </div>\n    <div class=\"ux-date-range-selector__second-picker\">\n        <ux-a-label [label]=\"secondPickersLabel\"></ux-a-label>\n        <ux-datepicker\n            #secondPicker\n            [noButton]=\"noButton\"\n            [placeholder]=\"secondPickersPlaceholder\"\n            [minDate]=\"firstPicker.input.value\"\n            [maxDate]=\"maxDate\"\n            (onDateSelect)=\"openFirstPicker($event)\"\n            [value]=\"endDateDefaultValue\">\n        </ux-datepicker>\n    </div>\n</div>\n", styles: [".ux-date-range-selector{display:flex}.ux-date-range-selector__second-picker{margin-left:5rem}\n"], dependencies: [{ kind: "component", type: i2.UxDatepickerComponent, selector: "ux-datepicker", inputs: ["styleClass", "value", "togglerIcon", "togglerLabel", "placeholder", "type", "startView", "e2eAttr", "minDate", "maxDate", "datepickerFilter", "isDatetimepicker", "noButton", "isReadOnly", "isDisabled", "disableInput", "disableButton", "disablePicker", "dateOutputFormat", "longDateFormat", "isClearable", "inputWidthClass", "restrictToRegex"], outputs: ["onInputChange", "onDateSelect"] }, { kind: "component", type: i3.UxLabelComponent, selector: "ux-a-label", inputs: ["styleClass", "labelStyleClass", "label", "subLabel", "iconClass", "iconTypeClass", "isIconRounded", "isIconSmall", "isIconTiny", "isIconLarge", "hasMarker", "markerTypeClass", "isClickable", "badgeLabel", "badgeTypeClass", "infos", "themeClass", "isDisabled", "isBoldLabel", "isSmall", "isLarge", "subLabelSizeLimit", "isRenderHTML", "tabindex", "ariaRole", "ariaExpanded", "ariaControls", "e2eAttr"], outputs: ["labelClicked"] }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxDateRangeSelectorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ux-date-range-selector', providers: [UX_DATERANGESELECTOR_ACCESSOR], encapsulation: ViewEncapsulation.None, template: "<div class=\"ux-date-range-selector {{ styleClass }}\" attr.data-e2e=\"{{ e2eAttr }}\">\n    <div class=\"ux-date-range-selector__first-picker\">\n        <ux-a-label [label]=\"firstPickersLabel\"></ux-a-label>\n        <ux-datepicker\n            #firstPicker\n            [noButton]=\"noButton\"\n            [placeholder]=\"firstPickersPlaceholder\"\n            [maxDate]=\"secondPicker.input.value || endDateDefaultValue ? secondPicker.input.value || endDateDefaultValue: maxDate\"\n            (onDateSelect)=\"openSecondPicker($event)\"\n            [value]=\"startDateDefaultValue\">\n        </ux-datepicker>\n    </div>\n    <div class=\"ux-date-range-selector__second-picker\">\n        <ux-a-label [label]=\"secondPickersLabel\"></ux-a-label>\n        <ux-datepicker\n            #secondPicker\n            [noButton]=\"noButton\"\n            [placeholder]=\"secondPickersPlaceholder\"\n            [minDate]=\"firstPicker.input.value\"\n            [maxDate]=\"maxDate\"\n            (onDateSelect)=\"openFirstPicker($event)\"\n            [value]=\"endDateDefaultValue\">\n        </ux-datepicker>\n    </div>\n</div>\n", styles: [".ux-date-range-selector{display:flex}.ux-date-range-selector__second-picker{margin-left:5rem}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.TranslateService }]; }, propDecorators: { styleClass: [{
                type: Input
            }], e2eAttr: [{
                type: Input
            }], firstPickersLabel: [{
                type: Input
            }], secondPickersLabel: [{
                type: Input
            }], firstPickersPlaceholder: [{
                type: Input
            }], secondPickersPlaceholder: [{
                type: Input
            }], noButton: [{
                type: Input
            }], maxDate: [{
                type: Input
            }], startDateDefaultValue: [{
                type: Input
            }], endDateDefaultValue: [{
                type: Input
            }], firstSelectedDate: [{
                type: Output
            }], secondSelectedDate: [{
                type: Output
            }], firstPicker: [{
                type: ViewChild,
                args: ['firstPicker']
            }], secondPicker: [{
                type: ViewChild,
                args: ['secondPicker']
            }] } });

class UxDateRangeSelectorComponentModule {
}
/** @nocollapse */ UxDateRangeSelectorComponentModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxDateRangeSelectorComponentModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ UxDateRangeSelectorComponentModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.3", ngImport: i0, type: UxDateRangeSelectorComponentModule, declarations: [UxDateRangeSelectorComponent], imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        UxDatepickerComponentModule,
        UxLabelComponentModule], exports: [UxDateRangeSelectorComponent] });
/** @nocollapse */ UxDateRangeSelectorComponentModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxDateRangeSelectorComponentModule, imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        UxDatepickerComponentModule,
        UxLabelComponentModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxDateRangeSelectorComponentModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        FormsModule,
                        ReactiveFormsModule,
                        TranslateModule,
                        UxDatepickerComponentModule,
                        UxLabelComponentModule
                    ],
                    exports: [
                        UxDateRangeSelectorComponent,
                    ],
                    declarations: [
                        UxDateRangeSelectorComponent,
                    ]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { UX_DATERANGESELECTOR_ACCESSOR, UxDateRangeSelectorComponent, UxDateRangeSelectorComponentModule };
